module.exports = __webpack_public_path__ + "img/drug1_cs_2.1.a6f64956.png";